module.exports = __webpack_public_path__ + "static/linkedin-logo-4ae0f385a7eb7c7f81489d333692da08.jpg";